/**
 * API base URL for Girder/DSA.
 * Docker: set via public/runtime-env.js (written on container start) so it is not stuck at old webpack-inlined values.
 * Local: uses CRA env from .env (REACT_APP_NEW_HOST_API).
 */
export function getApiBaseUrl() {
  if (typeof window !== 'undefined' && window.__RCM_API_BASE__) {
    return window.__RCM_API_BASE__;
  }
  return (
    process.env.REACT_APP_NEW_HOST_API ?? 'https://candygram.bdsa.io/api/v1'
  );
}
